<template>
  <div :id="echarts" ref="pieChart" class="container" />
</template>

<script>
import * as echarts from "echarts";
// import { EleResize } from '@/utils/eleResize'

export default {
  name: "pieChart",
  props: {
    // 接收父组件传递过来的信息
    PieData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    echarts() {
      return "echarts" + Math.random() * 100000;
    },
  },
  mounted: function () {
    const vm = this;
    vm.$nextTick(() => {
      vm.drawChart();
    });
  },
  created: () => {},
  methods: {
    drawChart() {
      var myChart = echarts.init(document.getElementById(this.echarts));
      var option = {
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
        },
        series: [
          {
            name: "Nightingale Chart",
            type: "pie",
            radius: [15, 75],
            center: ["50%", "50%"],
            roseType: "area",
            itemStyle: {
              borderRadius: 0,
            },
            data: this.PieData,
            labelLine: {
              // 这里配置飞线
              normal: {
                // 正常状态下的配置
                length: 5, // 第一段飞线长度
                length2: 2, // 第二段飞线长度，如果有两段的话
              },
            },
            label: {
              textStyle: {
                color: "rgba(255, 255, 255, 1)",
                fontSize: 10,
                fontWeight: "400",
              },
              formatter: "{b} {d}%",
            },
          },
        ],
      };
      option && myChart.setOption(option);
      const listener = function () {
        myChart.resize();
      };
      // EleResize.on(document.getElementById(this.echarts), listener)
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
